// client/src/utils/apiConfig.js
import axios from 'axios';

// Create an Axios instance with a base URL
const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production' 
    ? '/api' // In production, use relative path
    : 'http://localhost:5000/api' // In development, use full URL
});

export default api;